export enum CriterionComparator {
    GreaterThan = 'greaterthan',
    LessThan = 'lessthan',
    LessThanOrEqual = 'lessthanorequal',
    GreaterThanOrEqual = 'greaterthanorequal',
    Contains = 'contains',
    NumericEquals = 'equals',
}
